module.exports = __webpack_public_path__ + "img/logo.47fd3ab9.png";